import React from "react";
import { useSelector } from "react-redux";
import { numberWithCommas } from "../../utils";

function DashSubCard() {
  const url = "api/v2/dashboard/fetch-dashboard";
  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
  }));
  return (
    <div className="grid gap-4 grid-cols-[repeat(auto-fit,minmax(16rem,1fr))] mt-[1.25rem]">
      {data?.cardSubSummary?.map((item, index) => (
        <div
          key={index}
          className="rounded-[.75rem] bg-white   w-full px-[.9375rem] py-[1.25rem] font-lexendS"
        >
          <div className="ndovu-gradient-title text-[1rem] font-[400] leading-6 ">
            {item?.title}
          </div>

          <div className="space-y-[.5rem] text-[#545454] text-[.85rem] font-[300] leading-5 mt-[1rem]">
            {item?.details?.map((detail, i) => (
              <div key={i} className="flex justify-between">
                <span className="text-[#333]">{detail?.label}</span>
                <span
                  className={` ${
                    detail?.label === "Flagged Transactions"
                      ? "text-[#FB6551]"
                      : "text-[#000]"
                  } `}
                >
                  {numberWithCommas(detail?.value)}
                </span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default DashSubCard;
